import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function doesDeviceHaveHover() {
	try {
		return matchMedia("(hover: hover)").matches;
	} catch {
		return true;
	}
}

export function scrollIntoViewIfNeeded(opts: {
	selector: string;
	containerSelector?: string;
	scrollBehavior?: "instant" | "smooth";
	visibilityThreshold?: number;
	block?: "start" | "end" | "center" | "nearest";
}) {
	const {
		selector,
		containerSelector,
		scrollBehavior = "instant",
		visibilityThreshold = 1.0,
		block = "nearest",
	} = opts;
	const element = document.querySelector(selector);
	if (!element) return;

	const observer = new IntersectionObserver(
		(entries) => {
			const entry = entries[0];
			const visibleRatio = entry.intersectionRatio;

			if (visibleRatio < visibilityThreshold) {
				element.scrollIntoView({ behavior: scrollBehavior, block });
			}

			observer.disconnect();
		},
		{
			root: containerSelector ? document.querySelector(containerSelector) : null,
			threshold: visibilityThreshold,
		},
	);

	observer.observe(element);
	requestAnimationFrame(() => observer.disconnect());
}
